<div
  *ngIf="(isOffline | async) === false"
  class="d-flex justify-content-center align-items-center gap-3 bg-danger text-white px-1"
>
  {{ 'errorAlerts.noConnectionPanel' | translate }}
</div>
